import { CalendarCheck, ClipboardList, House, List as ListIcon, LogOut, Receipt, UsersRound } from "lucide-react";
import { Divider, List } from "@mui/material";
import { useAuthorizationContext, useClientPortalConfigContext } from "../../../../../context";
import { ROUTES } from "../../../../../routes";
import { useBookingAccess } from "../../../../../hooks/useBookingAccess";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { useClientPortalUserLogout } from "../../useClientPortalUserLogout";
import HeaderListItem from "../HeaderListItem";
import { getBookGroupBookingLabel } from "../../../../../utils/groupBookingLabel";

interface IHeaderListProps {
    handleClose: () => void;
}

export default function HeaderList({ handleClose }: IHeaderListProps) {
    const { logout, isLoading } = useClientPortalUserLogout();
    const { logoutUser } = useAuthorizationContext();
    const { clientPortalConfig } = useClientPortalConfigContext();
    const groupBookingLabel = getBookGroupBookingLabel(clientPortalConfig.groupBookingLabel);
    const { canBookAppointments, canBookClasses } = useBookingAccess();

    const handleLogout = async () => {
        await logout();
        await logoutUser();
        handleClose();
    };

    return (
        <List data-test-id="mobile_header_list">
            <HeaderListItem path={ROUTES.HOME.urlPath} title="Home" handleClose={() => handleClose()} icon={House} />
            {canBookAppointments && (
                <HeaderListItem
                    path={ROUTES.APPOINTMENT_BOOKING.urlPath}
                    title="Book Appointment"
                    handleClose={() => handleClose()}
                    icon={CalendarCheck}
                />
            )}
            {canBookClasses && (
                <HeaderListItem
                    path={ROUTES.CLASS_BOOKING.urlPath}
                    title={groupBookingLabel}
                    handleClose={() => handleClose()}
                    icon={UsersRound}
                />
            )}
            <Divider />
            {clientPortalConfig.featureAccess?.canViewUpcomingAppointments && (
                <HeaderListItem
                    path={ROUTES.APPOINTMENTS.urlPath}
                    title="Appointments"
                    handleClose={() => handleClose()}
                    icon={CalendarCheck}
                />
            )}
            {clientPortalConfig.featureAccess?.canViewInvoicesList && (
                <HeaderListItem
                    path={ROUTES.INVOICES.urlPath}
                    title="Invoices"
                    handleClose={() => handleClose()}
                    icon={Receipt}
                />
            )}
            {clientPortalConfig.featureAccess?.canAccessFormsPage && (
                <HeaderListItem
                    path={ROUTES.FORMS.urlPath}
                    title="Forms"
                    handleClose={() => handleClose()}
                    icon={ListIcon}
                />
            )}
            {clientPortalConfig.featureAccess?.canRequestWaitlist && (
                <HeaderListItem
                    path={ROUTES.WAITLIST_REQUEST.urlPath}
                    title="Waitlist Request"
                    handleClose={() => handleClose()}
                    icon={ClipboardList}
                />
            )}

            <Divider />
            <HeaderListItem title="Log out" handleClick={() => void handleLogout()} icon={LogOut} />
            {isLoading && <LoadingOverlay />}
        </List>
    );
}
